import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('component-swipe')
export class ComponentSwipe extends ChemistryLitElement {
  override connectedCallback(): void {
    super.connectedCallback();

    this.addEventListener('touchstart', this.handleTouchStart, false);
    this.addEventListener('touchmove', this.handleTouchMove, false);
  }

  override render() {
    return html` <slot></slot> `;
  }

  protected _xDown = null;
  protected _yDown = null;
  protected handleTouchStart(evt) {
    const firstTouch = this.getTouches(evt)[0];
    this._xDown = firstTouch.clientX;
    this._yDown = firstTouch.clientY;
  }

  protected getTouches(evt) {
    return evt.touches;
  }

  protected handleTouchMove(evt) {
    if (!this._xDown || !this._yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = this._xDown - xUp;
    const yDiff = this._yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* right swipe */
        this.dispatchEvent(new Event('swipe-right'));
      } else {
        /* left swipe */
        this.dispatchEvent(new Event('swipe-left'));
      }
    } else {
      if (yDiff > 0) {
        /* down swipe */
        this.dispatchEvent(new Event('swipe-down'));
      } else {
        /* up swipe */
        this.dispatchEvent(new Event('swipe-up'));
      }
    }
    /* reset values */
    this._xDown = null;
    this._yDown = null;
  }
}
